var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { "text-align": "center", margin: "12px" } },
      [_c("img", { attrs: { src: require("../assets/SSL-opti.png") } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }